import { effect, inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ApplicationService } from '@services/api-calls/application.service';

declare global {
    interface Window {
        cioanalytics: {
            identify(userId: string, traits?: Record<string, string>): void;
            page(properties?: Record<string, string>): void;
            reset(): void;
        };
    }
}

@Injectable({
    providedIn: 'root',
})
export class CustomerIoAnalyticsService {
    private applicationService = inject(ApplicationService);
    private lastIdentifiedGuid = '';
    private lastIdentifiedEmail = '';

    constructor() {
        if (!environment.production || window.location.hostname !== 'fairwayhomemortgageprotection.com') return;

        effect(() => {
            const guid = this.applicationService.applicationGuid();
            const client = this.applicationService.applicationInsuredClient();

            if (!guid) return;

            const email = client?.email ?? '';

            if (guid === this.lastIdentifiedGuid && email === this.lastIdentifiedEmail) return;
            if (guid === this.lastIdentifiedGuid && !email) return;

            this.identify(guid, client);
        });
    }

    identifyFromResponse(guid: string, client: { email?: string | null; first_name?: string | null; last_name?: string | null } | null): void {
        if (!guid) return;
        this.identify(guid, client);
    }

    private identify(guid: string, client: { email?: string | null; first_name?: string | null; last_name?: string | null } | null): void {
        const traits: Record<string, string> = {};
        if (client?.email) traits['email'] = client.email;
        if (client?.first_name) traits['first_name'] = client.first_name;
        if (client?.last_name) traits['last_name'] = client.last_name;

        this.lastIdentifiedGuid = guid;
        this.lastIdentifiedEmail = traits['email'] ?? '';

        window.cioanalytics?.identify(guid, traits);
    }
}
